export const routes = {
  main: "/",
  notFound: "/404",
  partners: "/v2/partners",
  partnerItem: "/v2/partners/:partner_id",
  newPartner: "/v2/partners/create",
  partnerContractsList: "/v2/partners/:partner_id/contracts",
  partnerComplexContractCreate:
    "/v2/partners/:partner_id/contracts/complex/create",
  partnerVirtualContractCreate:
    "/v2/partners/:partner_id/contracts/virtual/create",
  partnerComplexContractItem:
    "/v2/partners/:partner_id/contracts/complex/:contract_id",
  partnerComplexContractAgreement:
    "/v2/partners/:partner_id/contracts/complex/:contract_id/agreements/:agreement_id",
  partnerComplexContractAgreementCreate:
    "/v2/partners/:partner_id/contracts/complex/:contract_id/agreements/create",
  partnerVirtualContractItem:
    "/v2/partners/:partner_id/contracts/virtual/:contract_id",
  summaryReport: "/v2/partners/reports/summary",
  draftReport: "/v2/partners/reports/draft",
  finalReport: "/v2/partners/reports/finalReport",
  partnersDocDept: "/v2/partners-doc_dept",
  serviceTools: "/v2/service-tools",
  serviceToolsClient: "/v2/service-tools/:client_id",
  transactions: "v2/transactions",
  iframe: "/iframe",
  iframePartnerFinancesActs: "/iframe/partners/:partner_id/finances/acts",
  iframePartnerContracts: "/iframe/partners/:partner_id/contracts",
  iframePartnerVirtualContractItem:
    "/iframe/partners/:partner_id/contracts/virtual/:contract_id",
  iframePartnerComplexContractItem:
    "/iframe/partners/:partner_id/contracts/complex/:contract_id",

  iframePartnerComplexContractAgreement:
    "/iframe/partners/:partner_id/contracts/complex/:contract_id/agreements/:agreement_id",
  iframePartnerComplexContractAgreementCreate:
    "/iframe/partners/:partner_id/contracts/complex/:contract_id/agreements/create",
  iframePartnerClientsAccumulation:
    "/iframe/partners/:partner_id/partnerClients",
  iframeServiceTools: "/iframe/service-tools",
  iframeServiceToolsClient: "/iframe/service-tools/:client_id",
  iframePermissions: "/iframe/permissions",
  iframeTransferMoney: "/iframe/transfer-money/:client_id",
  iframeTargetingCountries: "/iframe/targetingcountry",
};
